/* RPNT · ajustes
   Con la bolsa abierta, el tabulador no se sale de la ventana y, al cerrarla,
   el foco vuelve al boton que la abrio. */
(function () {
  'use strict';
  var opener = null;
  function cajon() { return document.querySelector('[data-cajon]'); }
  function abierta() { var c = cajon(); return !!c && c.getAttribute('data-abierto') === 'true'; }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-abrir-bolsa],[data-anadir]');
    if (t) opener = t;
  }, true);
  var estabaAbierta = false;
  setInterval(function () {
    var ahora = abierta();
    if (estabaAbierta && !ahora && opener && document.contains(opener)) {
      try { opener.focus({ preventScroll: true }); } catch (err) {}
      opener = null;
    }
    estabaAbierta = ahora;
  }, 250);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !abierta()) return;
    var panel = cajon().querySelector('.cajon__panel'); if (!panel) return;
    var focos = Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return el.offsetParent !== null; });
    if (!focos.length) return;
    var primero = focos[0], ultimo = focos[focos.length - 1];
    if (!panel.contains(document.activeElement)) { e.preventDefault(); primero.focus(); return; }
    if (e.shiftKey && document.activeElement === primero) { e.preventDefault(); ultimo.focus(); }
    else if (!e.shiftKey && document.activeElement === ultimo) { e.preventDefault(); primero.focus(); }
  });
})();

/* Opciones con un solo valor (p. ej. "Color: Black" que crea Tapstitch): se marcan solas y se ocultan,
   porque el tono ya se muestra arriba y el cliente solo debe elegir la talla. */
(function () {
  'use strict';
  function preparar() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fcp-grupo]'), function (g) {
      var ins = g.querySelectorAll('input[data-fcp-valor]');
      if (ins.length !== 1) return;
      g.hidden = true;
      if (!ins[0].checked) {
        ins[0].checked = true;
        ins[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', preparar);
  else preparar();
})();